import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      // Goal slider variant styles
      "[&.goal-slider]:h-12",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className={cn(
      "relative w-full grow overflow-hidden rounded-full bg-secondary",
      // Default height
      "h-2",
      // Goal slider variant - taller track
      "[.goal-slider_&]:h-3 [.goal-slider_&]:bg-white/20"
    )}>
      <SliderPrimitive.Range className={cn(
        "absolute h-full bg-primary",
        // Goal slider variant - green gradient
        "[.goal-slider_&]:bg-gradient-to-r [.goal-slider_&]:from-[#34C759] [.goal-slider_&]:to-[#30D158]"
      )} />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className={cn(
      "block rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      // Default size
      "h-5 w-5",
      // Goal slider variant - larger thumb with glow
      "[.goal-slider_&]:h-7 [.goal-slider_&]:w-7 [.goal-slider_&]:border-[#34C759] [.goal-slider_&]:bg-white [.goal-slider_&]:shadow-[0_0_12px_rgba(52,199,89,0.5)]"
    )} />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
